import Box from "@mui/material/Box";
import { Divider, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const HeaderText = styled("p")({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
});

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  borderColor: "#cccccc",
}));

const TermsAndConditionsPage = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <HeaderText>{t("termsAndConditions")}</HeaderText>
      <CustomDivider />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <h3>{t("TermsAndConditionsMainTitle")}</h3>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("usingWebsiteTerms")}</b>
          <span>{t("usingWebsiteTermsDescription")}</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("ordersAndPayments")}</b>
          <span>{t("ordersAndPaymentsDescription")}</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("productDeliveryTerms")}</b>
          <span>{t("productDeliveryTermsDescription")}</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>{t("refundAndReturnPolicy")}</b>
          <span>{t("refundAndReturnPolicyDescription")}</span>
        </div>
      </div>
    </Box>
  );
};

export default TermsAndConditionsPage;
